module.exports = __webpack_public_path__ + "media/images/member_apple-e33d8f8d4b78a84e825024f57400518b.svg";